import Vue from 'vue';
import router from '@/router';
import VueAuthenticate from 'vue-authenticate';
import axios from 'axios';
import VueAxios from 'vue-axios';

import { cioanalytics, posthog } from '@/main';

Vue.use(VueAxios, axios);

const vueAuth = VueAuthenticate.factory(Vue.prototype.$http, {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  tokenName: 'access_token',
  loginUrl: '/session/login',
  registerUrl: '/session/register',
  passwordResetUrl: '/session/password_reset',
});

export default {
  state: {
    isAuthenticated:
      localStorage.getItem('vue-authenticate.vueauth_access_token') !== null,
    authPromise: null,
    authData: null,
  },

  getters: {
    isAuthenticated(state) {
      return state.isAuthenticated;
    },
  },

  mutations: {
    isAuthenticated(state, payload) {
      state.isAuthenticated = payload.isAuthenticated;
    },
    setAuthPromise(state, promise) {
      state.authPromise = promise;
    },
    setAuthData(state, promise) {
      state.authData = promise;
    },
  },

  actions: {
    async login(context, payload) {
      return vueAuth
        .login(payload.user, payload.requestOptions) //
        .then(async (res) => {
          //console.log(res); //
          if (res.data.errorCode === 'user_not_verified') {
            await router.push({ name: 'EmailSent' });
            return;
          }
          
          //console.log(res);
          if ((!res.data.error /*&& res.data.logged_in*/)) {
            if (payload.user.session_id) {
              localStorage.setItem(
                'vue-authenticate.vueauth_access_token',
                payload.user.session_id
              );
              context.commit('isAuthenticated', {
                isAuthenticated: vueAuth.isAuthenticated(),
              });
            }

            if(res?.data?.identify) {
              let authData = {};
              try {
                const raw = res?.data?.auth?.original;
                authData = raw ? JSON.parse(raw) : {};
                let identifyPayload = {
                  email: res?.data?.email,
                  firstName: res?.data?.firstName,
                  lastName: res?.data?.lastName,
                  ...authData // Auth data from /authenticate payload
                };
  
  
                cioanalytics.identify(res?.data?.uid, identifyPayload);
                cioanalytics.track('login', { success: true });

                posthog.identify(res?.data?.uid, {
                  email: res?.data?.email,
                  firstName: res?.data?.firstName,
                  lastName: res?.data?.lastName,
                });
                posthog.capture('user_logged_in');
              } catch (e) {
                //console.error("Failed to parse auth.original", e);
              }
            }

            // "Welcome to Bizminer 2.0" login toast removed (7.17 feedback #1)

            let screen = null;
            let defaultScreen = res?.data?.defaultScreen;
            if (this.$app.$store.getters.productType)
              screen = this.$app.$store.getters.productType;
            else if (defaultScreen && defaultScreen !== '')
              screen = defaultScreen.replace(/ /g, "");
            else
              screen = 'Search';

            await router.push({
              name: screen,
            });
          } else {
            //await this.$app.$store.dispatch('alerts/error', 'ERROR!');
            //payload.returnCode = res.data.errorCode;
            return;
            if(res.data.errorCode == "login_no_users") {
              await this.$app.$store.dispatch('alerts/error', 'Invalid credentials!');
            } else if(res.data.errorCode == "login_no_users_1") {
              await this.$app.$store.dispatch('alerts/error', 'Invalid credentials!');
            } else if(res.data.errorCode == "login_no_users_2") {
              await this.$app.$store.dispatch('alerts/error', 'Invalid credentials!');
            } else if(res.data.errorCode == "user_not_verified") {
              await this.$app.$store.dispatch('alerts/error', 'Email not verified!');
            } else if(res.data.errorCode == "login_many_users") {
              await this.$app.$store.dispatch('alerts/error', 'Can\'t log in, contact your sales representative!');
            } else if(res.data.errorCode == "login_access_disabled") {
              await this.$app.$store.dispatch('alerts/error', 'Can\'t log in, contact your sales representative!');
            } else if(res.data.errorCode == "login_existing_session") {
              await this.$app.$store.dispatch('alerts/error', 'Unable to log in / already logged in!');
            } else if(res.data.errorCode == "login_invalid_request") {
              await this.$app.$store.dispatch('alerts/error', 'Invalid parameters!');
            } else if(res.data.errorCode == "invalid_request_password") {
              await this.$app.$store.dispatch('alerts/error', 'Invalid credentials!');
            } else {
              await this.$app.$store.dispatch('alerts/error', 'Unable to log in / unknown!');
            }
          }
        });
    },

    async register(context, payload) {
      return vueAuth
        .register(payload.user, payload.requestOptions)
        .then(async (res) => {
          if (!res.data.error && res.data.registered) {
            if (payload.user.session_id) {
              localStorage.setItem(
                'vue-authenticate.vueauth_access_token',
                payload.user.session_id
              );

              context.commit('isAuthenticated', {
                isAuthenticated: vueAuth.isAuthenticated(),
              });
            }
            posthog.capture('user_registered');
            await this.$app.$store.dispatch(
              'alerts/success',
              'Registration complete.'
            );
            await router.push({
              name: 'Subscriptions',
              query: { s: 'renew-upgrade' },
            });
          } else if (
            res.data.error &&
            res.data.errorCode == 'register_username_exists'
          ) {
            this.$app.$store.dispatch(
              'alerts/error',
              'We already have an account with this email address.please login or reset your password'
            );
            await router.push({ name: 'Login' });
          } else {
            this.$app.$store.dispatch(
              'alerts/error',
              'Oops, something went wrong'
            );
          }
        });
    },

    async emailConfirm(context, payload) {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      var result = '';
      if (!currentSession) {
        var randomChars =
          'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

        for (var i = 0; i < 20; i++) {
          result += randomChars.charAt(
            Math.floor(Math.random() * randomChars.length)
          );
        }

        currentSession = result;
      }
      return axios
        .post(
          `${process.env.VUE_APP_API_BASE_URL}/user/verify_email`,
          {
            session_id: currentSession,
            user_id: payload.user_id,
            token: payload.token,
            verify_date: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} ` + new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds(),
          }
        )
        .then(async (res) => {
          if (!res.data.error && res.data.reset) {
            if (currentSession)
              localStorage.setItem(
                'vue-authenticate.vueauth_access_token',
                currentSession
              );
          } else {
            this.$app.$store.dispatch(
              'alerts/error',
              'Oops, something went wrong.'
            );
          }

          return res.data;
        });
    },

    async logout(context, payload) {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      if (currentSession) {
        axios
          .post(`${process.env.VUE_APP_API_BASE_URL}/session/logout`, {
            session_id: currentSession,
          })
          .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
              context.commit('SET_ERROR_BIT', true, { root: true });
              context.commit(
                'SET_ERROR_INFO',
                '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode,
                { root: true }
              );
            }
            if (!res.data.error) {
              
              cioanalytics.track('logout', { timestamp: new Date().toISOString() });
              // Reset analytics identity so next user/session starts clean
              cioanalytics.reset();
              posthog.reset();

              localStorage.removeItem('vue-authenticate.vueauth_access_token');
              context.commit('isAuthenticated', {
                isAuthenticated: false,
              });
              router.push({ name: 'Login' });
            }
          })
          .catch((err) => {
            context.commit('SET_ERROR_BIT', true, { root: true });
            context.commit('SET_ERROR_INFO', err.stack, { root: true });
          });
      } else {
        router.push({ name: 'Login' });
      }
    },

    async passwordReminder(context, payload) {
      return axios
        .post(
          `${process.env.VUE_APP_API_BASE_URL}/session/password_reset`,
          payload.user
        )
        .then(async (res) => {
          if (!res.data.error && res.data.reset) {
            posthog.capture('password_reset_requested');
            context.commit('isAuthenticated', {
              isAuthenticated: false,
            });
            localStorage.setItem(
              'vue-authenticate.temp_access_token',
              payload.user.session_id
            );
            this.$app.$store.dispatch(
              'alerts/success',
              'We sent password reset link to your email address.'
            );
          } else if (res.data.errorCode == 'password_reset_existing_session') {
            this.$app.$store.dispatch(
              'alerts/error',
              'You are already login in with this email and trying to reset a password.'
            );
          } else if (res.data.errorCode == 'password_reset_no_users') {
            this.$app.$store.dispatch(
              'alerts/error',
              'The email you input is incorrect.'
            );
          } else {
            this.$app.$store.dispatch(
              'alerts/error',
              'Oops, something went wrong.'
            );
          }

          return res.data;
        });
    },

    async recoverPassword(context, payload) {
      let tmpSession = localStorage.getItem(
        'vue-authenticate.temp_access_token'
      );
      if (!tmpSession) {
        var randomChars =
          'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var result = '';
        for (var i = 0; i < 20; i++) {
          result += randomChars.charAt(
            Math.floor(Math.random() * randomChars.length)
          );
        }

        tmpSession = result;
      }

      if (tmpSession) {
        return axios
          .post(
            `${process.env.VUE_APP_API_BASE_URL}/session/password_recover`,
            {
              session_id: tmpSession,
              recovery_hash: payload.recovery_hash,
              new_password: payload.new_password,
              email: payload.email,
              consolidateUID: payload.consolidateUID,
            }
          )
          .then(async (res) => {
            if (!res.data.error && res.data.recovered) {
              localStorage.removeItem('vue-authenticate.temp_access_token');
              this.$app.$store.dispatch(
                'alerts/success',
                'Password reset.'
              );
              router.push({ name: 'Login' });
            } else if (res.data.errorCode == 'recovery_used') {
              this.$app.$store.dispatch(
                'alerts/error',
                'A password has already been reset with that specific hash.'
              );
            } else if (res.data.errorCode == 'existing_session') {
              this.$app.$store.dispatch(
                'alerts/error',
                'You are already logged in.'
              );
            } else if (res.data.errorCode == 'recovery_invalid') {
              this.$app.$store.dispatch(
                'alerts/error',
                'The link from the email is invalid.'
              );
            } else if (res.data.errorCode == 'many_users') {
              this.$app.$store.dispatch(
                'alerts/error',
                'Many users with the same email were found.'
              );
            }

            return res.data;
          });
      } else {
        this.$app.$store.dispatch(
          'alerts/error',
          'Oops, something went wrong.'
        );
      }
    },

    async recoverPasswordLoggedIn(context, payload) {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      if (currentSession) {
        return axios
          .post(
            `${process.env.VUE_APP_API_BASE_URL}/session/password_recover_with_current`,
            {
              session_id: currentSession,
              current_password: payload.current_password,
              new_password: payload.new_password,
            }
          )
          .then(async (res) => {
            if (!res.data.error && res.data.recovered) {
              localStorage.removeItem('vue-authenticate.temp_access_token');
              this.$app.$store.dispatch(
                'alerts/success',
                'Password reset.'
              );
              // router.push({ name: 'Login' });
            } else if (res.data.errorCode == 'current_invalid') {
              this.$app.$store.dispatch(
                'alerts/error',
                'Current password is invalid.'
              );
            } else if (res.data.errorCode == 'recovery_invalid') {
              this.$app.$store.dispatch(
                'alerts/error',
                'The link from the email is invalid.'
              );
            } else {
              this.$app.$store.dispatch(
                'alerts/error',
                'Oops, something went wrong.'
              );
            }

            return res;
          });
      } else {
        this.$app.$store.dispatch(
          'alerts/error',
          'Oops, something went wrong.'
        );
      }
    },

    async authenticateUser({ commit, rootGetters, state }, payload = {}) {
      payload.reload = true;
      if (rootGetters['user/user_id'] && !payload?.reload) {
        return rootGetters['user/user'];
      }

      if (state.authPromise && !payload?.reload) {
        return state.authPromise;
      }

      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      var result = '';
      if (!currentSession) {
        var randomChars =
          'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (var i = 0; i < 20; i++) {
          result += randomChars.charAt(
            Math.floor(Math.random() * randomChars.length)
          );
        }
        currentSession = result;
        await localStorage.setItem(
            'vue-authenticate.vueauth_access_token',
            currentSession
        );
      }

      var axiosPromise = axios
        .post(`${process.env.VUE_APP_API_BASE_URL}/session/authenticate?cio_identify=1`, {
          session_id: currentSession,
        })
        .then((res) => {
          if(res.data && res.data.user)
            commit('setAuthData', res.data.user);

            if(res?.data?.identify) {
              let authData = {};
              try {
                const raw = res?.data?.auth?.original;
                authData = raw ? JSON.parse(raw) : {};
                let identifyPayload = {
                  email: res?.data?.email,
                  firstName: res?.data?.firstName,
                  lastName: res?.data?.lastName,
                  ...authData // Auth data from /authenticate payload
                };
  
                cioanalytics.identify(res?.data?.uid, identifyPayload);
                cioanalytics.page({ name: router.currentRoute.name, path:router.currentRoute.fullPath });

                posthog.identify(res?.data?.uid, {
                  email: res?.data?.email,
                  firstName: res?.data?.firstName,
                  lastName: res?.data?.lastName,
                });
              } catch (e) {
                //console.error("Failed to parse auth.original", e);
              }
              
            }

          localStorage.setItem("userIP", res.data.ip);

          if (res.data.academic) {
            localStorage.setItem("academicIP", res.data.academic.ip);
            commit('user/SET_ACADEMIC_IP', res.data.academic.ip);
          }
          if (res.data.user && res.data.userType && res.data.userType.academic) {
            if (res.data.academic)
              localStorage.setItem("academicIP", res.data.academic.ip);
            else
              localStorage.removeItem("academicIP");

            if (currentSession)
              localStorage.setItem(
                "vue-authenticate.vueauth_access_token",
                currentSession
              );

            commit('isAuthenticated', {
              isAuthenticated: true,
            });

            commit('user/SET_USER_TYPE', res.data.userType);
            if(res.data.user_account_access)
              commit('user/SET_USER_ACCESS', res.data.user_account_access);

            commit('user/SET_ALLOW_RETAIL', res.data.allowRetail);
            commit("user/SET_USER", res.data?.user);
            commit("user/SET_HOME", res.data?.user?.preferences?.defaultScreen
              ? res.data?.user?.preferences?.defaultScreen
              : "Search");

            if (router.history.current.fullPath === '/')
              router.push({
                name: 'Search',
              });
           /* if (router.history.current.fullPath === '/login')
              router.push({
                name: 'Search',
              });*/

          } else if (res.data.user) {
            if (
              res.hasOwnProperty('data') &&
              res.data.error &&
              res.data.errorCode !== 'invalid_session'
            ) {
              commit('SET_ERROR_BIT', true, { root: true });
              commit(
                'SET_ERROR_INFO',
                '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode,
                { root: true }
              );
            }
            if (!res.data.error) {
              localStorage.removeItem("academicIP");
              if (currentSession)
                localStorage.setItem(
                  "vue-authenticate.vueauth_access_token",
                  currentSession
                );
              if (!res.data || res.data.error) {
                return;
              }
              commit("user/SET_USER", res.data?.user);
              commit("user/SET_HOME", res.data?.user?.preferences?.defaultScreen
                ? res.data?.user?.preferences?.defaultScreen
                : "Search");
              commit('user/SET_USER_TYPE', res.data.userType);

              if(res.data.user_account_access)
                commit('user/SET_USER_ACCESS', res.data.user_account_access);

              commit('user/SET_ALLOW_RETAIL', res.data.allowRetail);
              localStorage.setItem("userFirstName", res.data.user.firstName);
              let data = res.data.subscriptions.data;
              data.forEach(elem => {

                let elDate = new Date(elem.expiration.slice(0, 10));
                let currentDate = new Date();
                if (currentDate < elDate) {
                  commit('user/SET_USER_IBBA2021', elem.subscription_code === 'ibba2021' ? true : false);
                }
              });

              commit('user/SET_USER_SUBSCRIPTIONS', res.data.coverage);
              commit(
                "user/SET_USER_SUBSCRIPTIONS_DATA",
                res.data.subscriptions.data[0] ?? {}
              );
              commit('PS_SET_CREDITS_AVAILABLE', res.data.list_credits.available);
              commit('PS_SET_CREDITS_TOTAL', res.data.list_credits.total);
              commit('PS_SET_CREDITS_USED', res.data.list_credits.used);
              commit('SET_TOS', res.data.onboarding.tos_checked);
              return res.data.user;
            }
            return false;
          } else if (
            router.history.current.fullPath !== "/register" &&
            router.history.current.fullPath !== "/password-reminder" &&
            !router.history.current.fullPath.includes('sample') &&
            !router.history.current.fullPath.includes('password-recover')
          ) {
            localStorage.removeItem("academicIP");
            commit('isAuthenticated', {
              isAuthenticated: false,
            });
            router.push({
              name: "Login",
            });
          }
        })
        .catch((err) => {
          /*context.*/commit('SET_ERROR_BIT', true, { root: true });
          /*context.*/commit('SET_ERROR_INFO', err.stack, { root: true });
        });

      commit('setAuthPromise', axiosPromise);
      return axiosPromise;
    },

    async getRandomString(context, length) {
      var randomChars =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var result = '';
      for (var i = 0; i < length; i++) {
        result += randomChars.charAt(
          Math.floor(Math.random() * randomChars.length)
        );
      }
      return result;
    },
  },
};
